/* טקסטים החוזרים בכל העמודים: ניווט, כותרת תחתונה ופרטי התקשרות. */

export const BRAND = {
  name: 'סינרו',
  logoAlt: 'סינרו',
  tagline: 'מעטפת אסטרטגית מלאה',
} as const;

export const CONTACT_DETAILS = {
  phoneLabel: 'טלפון',
  phone: '02-6542045',
  phoneHref: 'tel:026542045',
  emailLabel: 'מייל',
  email: 'cco@sy-nero.com',
  emailHref: 'mailto:cco@sy-nero.com',
  addressLabel: 'כתובת',
  address: 'הר חוצבים, ירושלים',
} as const;

export const NAV = {
  menuLabel: 'תפריט',
  departments: '8 מחלקות',
  advisors: 'היועצים שלנו',
  tracks: 'המסלולים שלנו',
  about: 'אודות',
  contactCta: 'בואו נדבר',
  skipToContent: 'דילוג לתוכן הראשי',
} as const;

export const FOOTER = {
  departmentsTitle: '8 מחלקות',
  aboutTitle: 'אודות',
  aboutLinks: {
    advisors: 'היועצים שלנו',
    who: 'מי אנחנו',
    vision: 'החזון',
    team: 'הצוות שלנו',
    terms: 'תקנון ותנאי שימוש',
  },
  contactTitle: 'צור קשר',
  copyright: '© 2026 סינרו · מעטפת אסטרטגית מלאה · הר חוצבים, ירושלים',
} as const;

export const HOME_CONTACT = {
  title: 'צור קשר.',
  lead: 'בשיחת היכרות קצרה נגדיר מטרות, נבין את הצורך, ונראה איזה מענה מקבלים מכל מחלקה.',
} as const;

/* טופס יצירת הקשר — תוויות, מצייני מקום והודעות מצב */
export const CONTACT_FORM = {
  title: 'להשארת פרטים',
  subtitle: 'נחזור אליכם בהקדם לתיאום שיחת היכרות.',
  nameLabel: 'שם מלא',
  namePlaceholder: 'השם שלכם',
  phoneLabel: 'טלפון',
  phonePlaceholder: '050-0000000',
  emailLabel: 'מייל',
  emailPlaceholder: 'name@email.com',
  messageLabel: 'הודעה',
  messagePlaceholder: 'ספרו לנו על העסק ועל הצורך',
  submitLabel: 'שליחת פנייה',
  submittingLabel: 'שולח...',
  note: 'הפרטים יישלחו ישירות אלינו.',
  genericError: 'אירעה שגיאה בשליחה, נסו שוב מאוחר יותר.',
  successTitle: 'ההודעה נשלחה בהצלחה',
  successBody: 'תודה שפניתם אלינו — ניצור איתכם קשר בהקדם האפשרי.',
  successClose: 'סגירה',
} as const;

export const NOT_FOUND = {
  code: '404',
  title: 'העמוד לא נמצא',
  body: 'ייתכן שהקישור שגוי או שהעמוד הוסר. אפשר לחזור לעמוד הבית ולהמשיך משם.',
  cta: 'חזרה לעמוד הבית',
} as const;

export const DEPARTMENT_PAGE = {
  backToHome: 'לעמוד הבית',
  servicesTitle: 'תחומי האחריות שלנו',
  otherDepartmentsTitle: 'מחלקות נוספות',
  advisorsCta: 'ליועצים שלנו',
  differentiatorLabel: 'הבידול שלנו:',
  notFoundTitle: 'המחלקה לא נמצאה',
  notFoundBody: 'ייתכן שהקישור שגוי או שהעמוד הוסר.',
} as const;
